module.exports = __webpack_public_path__ + "img/Listening_to_G.990bd15b.gif";